import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { browserRefresh } from 'src/app/app.component';

@Component({
  selector: 'app-signage-login',
  templateUrl: './signage-login.component.html',
  styleUrls: ['./signage-login.component.css']
})
export class SignageLoginComponent implements OnInit {
  loading=false;
  questionaireForm:FormGroup;

  error:any = '';
  success = '';
branchs;

currentUser:User;
loggedInUserBranch;
loggedInUserFullname;
loggedInUsername;
loggedInUserId;

  validationMessages = {
    'fullName': {
      'required': 'Full Name is required'
    },
    'phoneNumber': {
      'required': 'Phone Number is required'
    },
  
    'email': {
      'required': 'Email is required',
      'pattern' : 'Please enter a valid email'
    },
  
   'LookingFor': {
    'required': 'required'
  },
  'describesYouk': {
    'required': 'required'
  },
  'ageGroup': {
    'required': 'required'
  },
  'branch': {
    'required': 'required'
  },
  //'whatLoveProduct': {
   // 'required': 'required'
  //},
  'standOut': {
    'required': 'required'
  }
  
  };
  
  
  formErrors = {
    'fullName': '',
    'phoneNumber': '',
    'email': '',
    'lookingFor': '',
    'describesYou': '',
    'ageGroup': '',
    'branch': ''
  }
  
    constructor(private fb: FormBuilder,
      private router: Router,
      private _location: Location,
      private http: HttpClient,
      private actroute: ActivatedRoute,
      private _appointment: AppointmentService,
      private _authenticationService: AuthenticationService,) { 
          
        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser){
         // this.loggedInUsername=this.currentUser.userName;
        this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.loggedInUserBranch=this.currentUser.branch;
        this.loggedInUserId=this.currentUser.userName;
     
        }
      
        this.loggedInUserBranch='8810 Jane St';
        this.loggedInUsername='8810device';
        console.log(this.loggedInUsername)}


  ngOnInit(): void {

    this.getAllBranchs();

    this.questionaireForm = this.fb.group({
      pid: new FormControl(''),
      requestType: new FormControl('Browsing'),
       fullName: new FormControl('', [Validators.required]),
       phoneNumber: new FormControl('',[Validators.required]),
       email: new FormControl(''),
       branch: new FormControl(this.loggedInUserBranch),
       tag: new FormControl(''),
       companyName: new FormControl(''),
       describesYou: new FormControl(''),
       lookingFor: new FormControl(''),
       heardAboutUs: new FormControl(''),
       workWithFabricator: new FormControl(''),
       covid: new FormControl('NA'),
       createdBy: new FormControl('System')
       
     });


    
 
 
 
 
     //error handling
     this.questionaireForm.valueChanges.subscribe((data) => {
       this.logValidationErrors(this.questionaireForm);
     })
  }



  onSubmit(){
    this.loading=true;
    this.logValidationErrors(this.questionaireForm );
   

    //const categoryselect=this.questionaireForm.get('category').value;
   // if(categoryselect==="Machinery" || categoryselect==="Laptops" || categoryselect==="Desktops" || categoryselect==="Printer");

   console.log(this.questionaireForm.value);
         this._appointment.insertNewLogisticAppointment(this.questionaireForm.value)
      .subscribe(//subscribe to Observable
        response => {console.log('Success!', response);
        this.success=response['SUCCESS'];
        this.questionaireForm.reset;        
        document.getElementById("openTextSuccessModalButton").click();
    
      },
        error => {console.error('Error!', error);
        this.error=error.error.text ;
      }       
      );
  
          }


  actionAgree(){

  }

  getAllBranchs(){
    this._appointment.getAllBranchs().subscribe(
      (res) => {
  
        this.branchs = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }
  

  backClicked() {
    this._location.back();
  }


  refresh(): void {
    window.location.reload();
  }
  

  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
       //       console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }
}
